import store from '@/store'

export default {
    name: [(v) => !!v || 'Nama harus diisi'],

    username: [
        (v) => !!v || 'Username harus diisi',
        (v) => /^[a-zA-Z0-9_-]+$/.test(v) || 'Username tidak valid',
    ],

    email: [
        (v) => !!v || 'Email harus diisi',
        (v) => /^[\w.]+@[\w\d_-]+(\.\w+)+$/.test(v) || 'Email tidak valid',
    ],

    university: [(v) => !!v || 'Tipe Ujian harus diisi'],

    universityLists: [
        'Uji Kompetensi Profesi Ners',
        'Uji Kompetensi DIII Keperawatan',
        'Uji Kompetensi Profesi Bidan',
        'Uji Kompetensi DIII Kebidanan',
        'Uji Kompetensi Apoteker Indonesia (UKAI)',
        'Persiapan Program Studi Profesi Apoteker (PSPA)',
        'Persiapan Seleksi PPPK Tenaga Kesehatan',
        'Uji Kompetensi Nutrisionis',
        'Uji Kompetensi Rekam Medis',
    ],

    contact: [(v) => !!v || 'ID Line / WA harus diisi'],

    password: [(v) => !!v || 'Password harus diisi'],

    passwordConfirmation: [
        (v) => !!v || 'Konfirmasi password harus diisi',
        (v) => v == store.get('home/password') || 'Password tidak sama',
    ],
}
